import React from 'react'
import styles from "./index.module.scss"

const Heading2 = ({ text }) => (
  <h2 className={styles.heading}>
    { text }
  </h2>
)
export default Heading2
